import graphqlClient from 'src/graphql/client';
import { prospect } from './fragments/prospect.graphql';
import gql from 'graphql-tag';
import type { Prospect } from './types';
import { removeNullValueFromObject } from './utils';
import type { HomeLocationDescriptionInput } from 'src/stores/JobApplicationStore/types';

export const query = gql`
  query prospectByAdcentreProspectId(
    $positionId: ID!
    $advertiserId: ID!
    $adcentreProspectId: ID!
    $homeLocationDescriptionInput: CM_LocationDescriptionInput!
  ) {
    prospectByAdcentreProspectId(
      input: {
        positionId: $positionId
        advertiserId: $advertiserId
        adcentreProspectId: $adcentreProspectId
      }
    ) {
      ...prospect
    }
  }
  ${prospect}
`;

const fetchProspectByAdcentreProspectId = async (variables: {
  adcentreProspectId: string;
  advertiserId: string;
  positionId: string;
  homeLocationDescriptionInput: HomeLocationDescriptionInput;
}): Promise<Prospect | null> => {
  const result = await graphqlClient.query({
    variables,
    query,
  });
  const fetchedProspect = result.data.prospectByAdcentreProspectId as Prospect;
  if (fetchedProspect) {
    removeNullValueFromObject(fetchedProspect);
  }
  return fetchedProspect;
};

export default fetchProspectByAdcentreProspectId;
